export const dismissReason = {
    ProsecutionPerempt: 1,
    DefensePerempt: 2,
    ForCause: 3,
    ForHardship: 4,
    BothPerempt: 5
};

/**
 * Maps a numeric dismiss reason constant to the { reason, discarder } format
 * expected by the Dexie dismissJuror action.
 */
export function mapDismissReason(numericReason) {
    switch (numericReason) {
        case dismissReason.ProsecutionPerempt:
            return { reason: 'peremptory', discarder: 'prosecutor' };
        case dismissReason.DefensePerempt:
            return { reason: 'peremptory', discarder: 'defense' };
        case dismissReason.BothPerempt:
            return { reason: 'peremptory', discarder: 'both' };
        case dismissReason.ForCause:
            return { reason: 'cause' };
        case dismissReason.ForHardship:
            return { reason: 'hardship' };
        default:
            return {};
    }
}
